import React from 'react';
import { ContainerLineUI } from '../../../UIComponents/ContainerLine/styles';
import Paragraph from '../../../UIComponents/Paragraph';
import ParagraphDangerous from '../../../UIComponents/ParagraphDangerous';
import Title from '../../../UIComponents/Title';
import DefaultCategoryGallery from '../DefaultCategoryGallery';

interface IProps {
    bigAreas: Record<string, any>[];
    posters: Record<string, any>[];
    showPoster: Function;
    eixo: string;
}

const DisplayCientificLibraryCategory: React.FC<IProps> = ({ eixo, bigAreas, posters, showPoster }) => {


    return <ContainerLineUI className='full-width column'  >  <ContainerLineUI className='full-width column'  >
        <ContainerLineUI className='max-1200 column column-start pad' style={{ padding: '30px' }}>
            <Title style={{ textAlign: 'center', width: '100%' }}>{eixo ? eixo?.toUpperCase() : "Receitas CCGL"}</Title>
            <Paragraph style={{ textAlign: 'center', width: '100%' }}>Conheça o conteúdo disponível</Paragraph>
        </ContainerLineUI>
        <DefaultCategoryGallery setCallback={showPoster} filtered={posters} />
    </ContainerLineUI>

    </ContainerLineUI>
}

export default DisplayCientificLibraryCategory;